import React from 'react'

export default function button(props) {
  return (
    <>
                    <li><button>{props.buttonName}</button></li>
    </>
  )
}
